<template>
  <header class="el-header header" style="height: 60px;">
    <div class="left">
      <img alt=""
           src="@/assets/logo.png"
           class="nav-logo">
      <span class="nav-title">五创电子招标平台</span>
    </div>
    <div class="middle">
      <span @click="changeNavActive('/','index')"
            :class="{'text':true, 'active': $store.getters.navActive === 'index'}">首页</span>
      <span @click="changeNavActive('/bid','notice')"
            :class="{'text':true, 'active': $store.getters.navActive === 'notice'}">公告信息</span>
      <span @click="changeNavActive('/help','help')"
            :class="{'text':true, 'active': $store.getters.navActive === 'help'}">帮助中心</span>
    </div>
    <div class="right">
      <el-input placeholder="请输入" v-model="searchKeyword">
        <i @click="search" style="cursor: pointer" slot="suffix" class="el-icon-search"></i>
      </el-input>
    </div>
  </header>
</template>

<script>
import {mapGetters} from 'vuex'


export default {
  components: {},
  computed: {
    ...mapGetters(["navActive"])
  },
  data() {
    return {
      searchKeyword: "",
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: 'bid',
        query: {}
      })
      this.$EventBus.$emit("on-search", this.searchKeyword);
    },
    changeNavActive(router, active) {
      this.$router.push({
        path: router
      })
      this.$store.commit('updateNavActive', active)
    }
  }
}
</script>

<style scoped>

.header {
  width: 80%;
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0 !important;
}

.header .left {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.header .middle {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 0 50px;
  font-size: 16px;
  color: #666;
  font-weight: 500;
  cursor: pointer;
}

.header .middle .active {
  color: #fff;
  background: #28e;
}

.header .middle .text {
  padding: 20px;
}

.header .right {
  width: 280px;
}


/deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: white;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dedede;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  color: #515152;
  display: inline-block;
  font-size: inherit;
  height: 34px;
  line-height: 34px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;

  border-radius: 16px !important;
  line-height: 32px !important;
  height: 32px !important;
  background-color: #f4f4f4;
  padding-left: 16px;
}


/deep/ .el-input__suffix {
  position: absolute;
  height: 100%;
  right: 5px;
  top: 0;
  text-align: center;
  color: #c0c4cc;
  -webkit-transition: all .3s;
  transition: all .3s;
  pointer-events: none;
  width: 25px;
}


/deep/ .el-icon-search {
  line-height: 30px;
}

.nav-title {
  font-size: 18px;
  vertical-align: top;
  font-weight: 500;
  margin-left: 10px;
}

.nav-logo {
  width: 130px;
  margin-top: 2px;
  height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue